import { MOCK_SITE_SAMPLE_IDS } from "./constants";

export const getProfile = () => {
  return {
    sites: [
      {
        site: MOCK_SITE_SAMPLE_IDS.default,
        name: "Battery, EV and Hot Water",
      },
      {
        site: MOCK_SITE_SAMPLE_IDS.optimisation_amber,
        name: "EmpowerIQ - Wholesale Price Spike",
        mock_time: "17:35",
      },
      {
        site: MOCK_SITE_SAMPLE_IDS.optimisation_amber_solar_topup,
        name: "EmpowerIQ - Wholesale Midday Solar Top-up",
        mock_time: "11:50",
      },
      {
        site: MOCK_SITE_SAMPLE_IDS.optimisation_tou_ev,
        name: "EmpowerIQ - ToU EV Free Charging",
        mock_time: "13:05",
      },
      {
        site: MOCK_SITE_SAMPLE_IDS.optimisation_tou,
        name: "EmpowerIQ - ToU Overnight Load Shifting",
        mock_time: "04:35",
      },
      {
        site: MOCK_SITE_SAMPLE_IDS.optimisation_tou_solar_topup,
        name: "EmpowerIQ - ToU Midday Solar Top-up",
        mock_time: "13:05",
      },
      {
        site: MOCK_SITE_SAMPLE_IDS.notification_backup,
        name: "Notifications",
      }
    ],
    about: {
      Model: "Elektrobank 14",
      Serial: "EB010100000000",
      "Battery Capacity": "15.4 kWh",
      "Usable Battery Capacity": "14 kWh",
      "Continuous Output Power (Grid)": "5 kW",
      "Continuous Output Power (Backup)": "4.6 kW",
    },
    profile: {
      Name: "Empower Energy",
      Address:
        "Unit 7 81 Frenchs Forest E, Frenchs Forest NSW 2086, Australia",
    },
  };
};
